import { render, staticRenderFns } from "./QueryFormFilters.vue?vue&type=template&id=24b161bd"
import script from "./QueryFormFilters.vue?vue&type=script&lang=ts"
export * from "./QueryFormFilters.vue?vue&type=script&lang=ts"
import style0 from "./QueryFormFilters.vue?vue&type=style&index=0&id=24b161bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports